/**
 * Created by andrey on 27.10.2025
 */

const SyncTransport = function (synchronizer) {
    this.synchronizer = synchronizer;

    this.config = {
        sendInterval: 2000
    };

    this.sendTasks = {};
    this.sendTasksRunning = undefined;
    this.syncOut = undefined;
    this.syncOutRunning = undefined;

    this.bus = new ConnectorEventEmitter();
};

SyncTransport.prototype.initialize = function () {
    let data = connector.dataLoader.load(SimpleDataLoader.TYPES.SYNC_TRANSPORT);

    if (!data) {
        const sync = connector.dataLoader.load(SimpleDataLoader.TYPES.SYNC) || [];
        const sendTasks = Array.isArray(sync) ? sync : sync.sendTasks;
        data = { sendTasks };
    }

    data.sendTasks = data.sendTasks || [];

    for (const type of data.sendTasks) {
        this.sendTasks[type] = true;
    }

    this.syncOut = data.syncOut;

    if (connector.dataLoader.load(SimpleDataLoader.TYPES.SYNC)) {
        connector.dataLoader.remove(SimpleDataLoader.TYPES.SYNC);
        this.save();
    }
};

SyncTransport.prototype.connect = function () {
    this._connect(() => {
        this.connected = true;
        this.bus.trigger("connected");
    });
};

SyncTransport.prototype.isConnected = function () {
    return this.connected;
};

SyncTransport.prototype.whenConnected = function (callback) {
    this.bus.once("connected", callback);
};

SyncTransport.prototype.save = function () {
    connector.dataLoader.save(SimpleDataLoader.TYPES.SYNC_TRANSPORT, {
        sendTasks: Object.keys({ ...this.sendTasks, ...this.sendTasksRunning }),
        syncOut: this.syncOut || this.syncOutRunning
    });
};

SyncTransport.prototype.reset = function () {
    this.sendTasks = {};
    this.sendTasksRunning = undefined;
    this.syncOut = undefined;
    this.syncOutRunning = undefined;

    this.sending && this.sending.clear();
    this.checking && this.checking.clear();

    this.save();
};

SyncTransport.prototype.addSendTask = function (...types) {
    let changed = false;

    for (const type of types) {
        if (!this.sendTasks[type]) {
            this.sendTasks[type] = true;
            changed = true;
        }
    }

    if (changed) {
        this.save();
    }
};

SyncTransport.prototype.setSyncOut = function () {
    this.sendTasks = {};
    this.syncOut = true;

    this.save();
};

SyncTransport.prototype.send = function (callback) {
    callback = callback || function () {};

    if (this.sending || !this.canSend()
        || this.sendErrorTime && this.sendErrorTime + SyncTransport.SEND_AFTER_ERROR_TIMEOUT > Date.now()) {
        callback();
        return;
    }

    const getSendValue = () => {
        if (this.syncOut) {
            const snapshot = this.synchronizer.getLocalSnapshot();
            snapshot.syncout = true;
            return snapshot;
        }

        const adapters = this.synchronizer.adapters;

        const sendValue = {};

        for (const type in this.sendTasks) {
            if (adapters[type] && adapters[type].getInfo) {
                const task = adapters[type].getInfo();
                sendValue[type] = task;
            }
        }

        return sendValue;
    };

    const sendValue = getSendValue();

    if (Object.keys(sendValue).length === 0) {
        callback();
        return;
    }

    console.log("Sending update ", sendValue);

    this.sendTasksRunning = this.sendTasks;
    this.sendTasks = {};

    this.syncOutRunning = this.syncOut;
    this.syncOut = undefined;

    const sendValueLength = JSON.stringify(sendValue).length;
    const keyLengths = Object.keys(sendValue).map((key) => [key, (JSON.stringify(sendValue[key]) || "").length]);
    if (sendValueLength > 200000 || keyLengths.some(([, length]) => length > 65535)) {
        const details = keyLengths.map(([key, length]) => `${key} - ${length}`).join(", ");
        this.synchronizer.trigger("stream:error", `synchronizer sync entity too large - ${sendValueLength}, ${details}`);
    }

    const sending = this.sending = {
        onSuccess: (response = {}) => {
            sending.clear();

            this.sendTasksRunning = undefined;
            this.syncOutRunning = undefined;

            if (response.error && response.error === SyncTransport.SESSION_EXPIRED) {
                console.log("onSend: session needs renewal");
                callback("sessionExpired");
                return;
            }

            if (response === 0) {
                console.log("error saving object");
            }

            // console.log("Success: ", response);
            this.save();

            callback();
        },

        onError: (code) => {
            sending.clear();

            console.log("Failure sync out: ", code);

            this.sendTasks = { ...this.sendTasksRunning, ...this.sendTasks };
            this.sendTasksRunning = undefined;

            this.syncOut = this.syncOutRunning || this.syncOut;
            this.syncOutRunning = undefined;

            this.sendErrorTime = Date.now();

            callback(connector.CODE_FAILED);
        },

        clear: () => {
            sending.onSuccess = () => {};
            sending.onError = () => {};
            connector.timeouts.clearTimeout(timeout);
            this.sending = undefined;
        }
    };

    const timeout = connector.timeouts.setTimeout(() => sending.onError("timeout"), SyncTransport.REQUEST_TIMEOUT);

    this._send(
        sendValue,
        (response) => sending.onSuccess(response),
        (code) => sending.onError(code)
    );
};

SyncTransport.prototype.checkSession = function (header, callback) {
    if (this.checking) {
        callback("alreadyRunning");
        return;
    }

    const accessToken = connector.platform.getAccessToken() || "undefined";

    const data = {
        ...header,
        accessToken,
        source: connector.info.source,
        localStorageEnabled: connector.dataLoader.enabled
    };

    const checking = this.checking = {
        onSuccess: (response = {}) => {
            checking.clear();

            callback(connector.CODE_SUCCEED, response);
        },

        onError: (err) => {
            checking.clear();

            console.log("load progress error", err);

            if (err && err.status === 403 && accessToken === "undefined" && connector.platform.getAccessToken()) {
                this.checkSession(header, callback);
                return;
            }

            callback(err || connector.CODE_FAILED);
        },

        clear: () => {
            checking.onSuccess = () => {};
            checking.onError = () => {};
            connector.timeouts.clearTimeout(timeout);
            this.checking = undefined;
        }
    };

    const timeout = connector.timeouts.setTimeout(() => checking.onError("timeout"), SyncTransport.REQUEST_TIMEOUT);

    this._checkSession(
        data,
        (response) => checking.onSuccess(response),
        (err) => checking.onError(err)
    );
};

SyncTransport.prototype._connect = function (callback) {
    callback();
};

SyncTransport.prototype._send = function () {
};

SyncTransport.prototype._checkSession = function () {
};

SyncTransport.prototype.canSend = function () {
    return true;
};

SyncTransport.SESSION_EXPIRED = 99;

SyncTransport.SEND_AFTER_ERROR_TIMEOUT = connector.utils.parseInterval("60 seconds");

SyncTransport.REQUEST_TIMEOUT = connector.utils.parseInterval("2 minutes");